import { Application } from "@hotwired/stimulus"
import Reveal from "@stimulus-components/reveal"

import { appsignal } from "../appsignal";
import { installErrorHandler } from "@appsignal/stimulus";

const application = Application.start()
installErrorHandler(appsignal, application);

// Install the Stimulus Reveal controller from the npm package
application.register("reveal", Reveal)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
